import { Form, Formik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BigBlock, SmallBlock } from '@zimpel/common/components/Blocks';
import ButtonGroup from '@zimpel/common/components/ButtonGroup/ButtonGroup';
import { PrimaryButton } from '@zimpel/common/components/Buttons';
import { FormikTextinput } from '@zimpel/common/components/formikAdapters';
import { GridCol, GridRow } from '@zimpel/common/components/Grid';
import { H2 } from '@zimpel/common/components/Headlines';
import Label from '@zimpel/common/components/Label';
import { AppLink } from '@zimpel/common/components/Links';
import t from '@zimpel/common/helpers/i18n';
import useHandleErrors from '@zimpel/common/hooks/useHandleErrors';
import useHandleValidationErrors from '@zimpel/common/hooks/useHandleValidationErrors';
import { useNotificationContext } from '@zimpel/AppContext';
import { resetPassword } from './api';
import Layout from './Layout';

const StyledLink = styled(AppLink)`
  margin-left: auto;
`;

const PasswordReset = () => {
  const { notifySuccess } = useNotificationContext();
  const navigate = useNavigate();
  const handleValidationErrors = useHandleValidationErrors();
  const handleErrors = useHandleErrors();

  return (
    <Layout>
      <GridRow>
        <GridCol $width={10} $padLeft={2}>
          <H2>{t('authentication.reset_password.header')}</H2>
          <Formik
            onSubmit={async (values, { setErrors }) => {
              handleErrors(async () => {
                await handleValidationErrors({ setErrors }, async () => {
                  const { username } = values;
                  await resetPassword({ username });
                  notifySuccess(t('authentication.reset_password.success_msg'));
                  navigate('/login');
                });
              });
            }}
            initialValues={{
              username: '',
            }}
          >
            {({ isSubmitting }) => (
              <SmallBlock>
                <Form>
                  <Label htmlFor="username">
                    {t('authentication.username.label')}
                  </Label>
                  <FormikTextinput id="username" name="username" autoFocus />

                  <BigBlock>
                    <ButtonGroup>
                      <PrimaryButton disabled={isSubmitting} $width="s" $height="l" type="submit">
                        {t('authentication.send_button')}
                      </PrimaryButton>
                      <StyledLink to="/login">{t('authentication.login.back_link')}</StyledLink>
                    </ButtonGroup>
                  </BigBlock>
                </Form>
              </SmallBlock>
            )}
          </Formik>

        </GridCol>
      </GridRow>
    </Layout>
  );
};

export default PasswordReset;
